/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  Ref,
  useMemo,
} from "react";
import Modal from "react-bootstrap/Modal";
import { TfiClose } from "react-icons/tfi";
import {
  useTable,
  useRowSelect,
  useFilters,
  useGlobalFilter,
  Column,
  Row,
} from "react-table";
import { MdEdit } from "react-icons/md";
import { FaExclamationTriangle, FaEye, FaMicroscope, FaReact, FaSortDown, FaSortUp, FaTrashAlt } from "react-icons/fa";
import { IoMdClose, IoMdDownload } from "react-icons/io";
import { BiSearch } from "react-icons/bi";
import { MdLockReset } from "react-icons/md";
import AlertModal from "../alertModal";
import { Form } from "react-bootstrap";
import { userService } from "../../service/userService";
import Select from "react-select";
import FilterSec from "./partials/filterSec";
import TableButtonSec from "./partials/tableButtonSec";
import { FaSort } from "react-icons/fa";
import { ImArrowUpRight2 } from "react-icons/im";
import { useTranslation } from "react-i18next";
import CustomLoader from "../loader/loader";

interface CustomTableProps {
  columns: Column[];
  data: any[];
  isEditable?: boolean;
  showFullFilters?: boolean;
  isActionVisible: boolean;
  isViewVisible: boolean;
  removable?: boolean;
  showReasonField?: boolean;
  showRemarkField?: boolean;
  isSeachable?: boolean;
  isTempDeletable?: boolean;
  isToggleStatus?: boolean;
  isResetPassword?: boolean;
  isNavigateFlora?: boolean;
  addButton?: boolean;
  addButtonText?: string;
  buttonWithCloseIcon?: boolean;
  buttonWithCloseIconText?: string;
  discardButton?: boolean;
  discardButtonText?: string;
  startButton?: boolean;
  startButtonText?: string;
  endButton?: boolean;
  endButtonText?: string;
  approveButton?: boolean;
  approveButtonText?: string;
  rejectButton?: boolean;
  rejectButtonText?: string;
  plateBatch?: any[];
  plateSerialNumber?: any[];
  lotCodeNumber?: any[];
  areaListNumber?: any[];
  areaList?: any[];
  removeSortList?: any[];
  inspectionReasons?: any[];
  ReasonList?: any[];
  reportName?:any[];
  fileStatus?:string;
  ActivityType?:any[];
  GradeTypes?:any[];
  prodScheduleList?:any[];
  productionStatus?:string;
  productList?:any[];
  areaGrade?:any[];
  assignee?:any[];
  generatedby?:any[]
  locationCategory?:any[];
  areaDropList?:any[];
  process?:any[];
  locationList?:any[];
  totalElements: number;
  tableHead: string;
  isQrDownloadable?: boolean;
  changeRoleButton?: boolean;
  changeRoleButtonText?: string;
  actionCheckOrangeButton?: boolean;
  actionCheckOrangeBtnText?: string;
  actionCheckOrangeButton2?: boolean;
  actionCheckOrangeButton3?: boolean;
  actionCheckOrangeBtnText2?: string;
  actionCheckOrangeBtnText3?: string;
  addPlateUploadBtn?: boolean;
  addPlateUploadText?: string;
  showBlueBtn?: boolean;
  disableBlueBtn?: boolean;
  blueBtnText?: string;
  blueBtnTextTitle?: string;
  showBatchFilter?: boolean;
  showPlateStatus?: boolean;
  showSerielNoFilter?: boolean;
  showLotCodeFilter?: boolean;
  showPlateTypeFilter?: boolean;
  showProcessButton?: boolean;
  sopDownloadButton?: boolean;
  showaddLotButton?: Boolean;
  showassignUserButton?: Boolean;
  assignUserBtnText?: string;
  showTableBtn?: Boolean;
  tableBtnText?: string;
  showQrGenerateButton?: Boolean;
  showFromDateFilter?:boolean;
  showFromDateLabApproval?:boolean;
  showToDateLabApproval?:boolean;
  showToDateFilter?:boolean;
  dateType?: string;
  showYearFilter?:boolean;
  showInventoryFromDateFilter?:boolean;
  // onSelectRow: (selectedRows: string[]) => void;
  onViewClick?: (id: string, viewValue: boolean) => void;
  clearAll?: boolean;
  onStartClick?: (selectedRows: string[]) => void;
  onEndClick?: (selectedRows: string[]) => void;
  onFilterClick?: (key: string, value: any) => void;
  onSortClick?: (key: string, value: boolean) => void;
  onCountChange?: (slno: string, value: number) => void;
  onRemarkChange?: (slno: string, value: number, label: string) => void;
  onUseEffectRequired?: () => void;
  onAddClick?: () => void;
  onActionCheckOrangeButtonClick?: (slno: string[]) => void;
  onActionCheckOrangeButtonClick2?: (slno: string[]) => void;
  onActionCheckOrangeButtonClick3?: (slno: string[]) => void;
  onDiscardClick?: () => void;
  onEditClick?: (id: string, tableBtnText?: string) => void;
  onRoleDEpartmentClick?: (id: string[]) => void;
  onActionClick?: (selectedRows: string[]) => void;
  onRemoveClick?: (rowId: string) => void;
  onStatusChange?: (id: any, status: string) => void;
  onCellClick?: (rowData: any[]) => void;
  onResetPassClick?: (id: any) => void;
  onNavigateFloraClick?: (id: any) => void;
  onQrDownloadClick?: (slno: string[], type: string) => void;
  onUploadClick?: () => void;
  onBlueBtnClick?: () => void;
  onRowClick?: (id: string) => void;
  onCloseBtnClick?: () => void;
  onTempDeleteClick?: (id: string) => void;
  onAssignUserClick?: (id: string) => void;
  emptyTableText?: string;
  showStatusFilter?: boolean;
  actionButtons?: any[];
}

const CustomTable: React.FC<CustomTableProps> = ({
  data,
  columns,
  totalElements,
  isEditable,
  showFullFilters,
  isActionVisible,
  isViewVisible,
  tableHead,
  removable,
  showReasonField,
  showRemarkField,
  isSeachable,
  isTempDeletable,
  isToggleStatus,
  isResetPassword,
  isNavigateFlora,
  addButton,
  addButtonText,
  buttonWithCloseIcon,
  buttonWithCloseIconText,
  discardButton,
  discardButtonText,
  startButton,
  startButtonText,
  endButton,
  endButtonText,
  showStatusFilter,
  approveButton,
  approveButtonText,
  rejectButton,
  rejectButtonText,
  plateBatch,
  plateSerialNumber,
  lotCodeNumber,
  areaListNumber,
  isQrDownloadable,
  changeRoleButton,
  changeRoleButtonText,
  actionCheckOrangeButton,
  actionCheckOrangeBtnText,
  actionCheckOrangeButton2,
  actionCheckOrangeButton3,
  actionCheckOrangeBtnText2,
  actionCheckOrangeBtnText3,
  addPlateUploadBtn,
  addPlateUploadText,
  showBlueBtn,
  blueBtnText,
  blueBtnTextTitle,
  disableBlueBtn,
  showBatchFilter,
  showSerielNoFilter,
  showLotCodeFilter,
  showPlateStatus,
  areaList,
  removeSortList,
  inspectionReasons,
  ReasonList,
  reportName,
  fileStatus,
  ActivityType,
  GradeTypes,
  prodScheduleList,
  productionStatus,
  productList,
  process,
  locationList,
  areaGrade,
  assignee,
  generatedby,
  locationCategory,
  areaDropList,
  showPlateTypeFilter,
  showProcessButton,
  sopDownloadButton,
  showaddLotButton,
  showassignUserButton,
  assignUserBtnText,
  showTableBtn,
  tableBtnText,
  showQrGenerateButton,
  showFromDateFilter,
  showFromDateLabApproval,
  showToDateLabApproval,
  showInventoryFromDateFilter,
  showToDateFilter,
  dateType,
  showYearFilter,
  // onSelectRow,
  onViewClick,
  clearAll,
  onStartClick,
  onEndClick,
  onUseEffectRequired,
  onFilterClick,
  onSortClick,
  onCountChange,
  onRemarkChange,
  onCellClick,
  onAddClick,
  onActionCheckOrangeButtonClick,
  onActionCheckOrangeButtonClick2,
  onActionCheckOrangeButtonClick3,
  onUploadClick,
  onBlueBtnClick,
  onDiscardClick,
  onEditClick,
  onActionClick,
  onRemoveClick,
  onStatusChange,
  onResetPassClick,
  onNavigateFloraClick,
  onQrDownloadClick,
  onRoleDEpartmentClick,
  onAssignUserClick,
  onRowClick,
  emptyTableText,
  onCloseBtnClick,
  onTempDeleteClick,
  actionButtons,
}) => {
  const [newData, setData] = useState(data);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  
  // Clear completed items from selection when data changes
  useEffect(() => {
    // Find all completed row IDs
    const completedRowIds = data
      .filter(row => row.is_completed === "Completed")
      .map(row => row.slno);
      
    if (completedRowIds.length > 0) {
      // Remove any completed items from selection
      setSelectedRows(prev => 
        prev.filter(slno => !completedRowIds.includes(slno))
      );
    }
  }, [data]);
  const [showStartAlert, setShowStartAlert] = useState(false);
  const [showEndAlert, setShowEndAlert] = useState(false);
  const [showApproveAlert, setShowApproveAlert] = useState(false);
  const [showRejectAlert, setShowRejectAlert] = useState(false);

  const [showRemoveAlert, setShowRemoveAlert] = useState(false);
  const [showRemoveLotAlert, setShowRemoveLotAlert] = useState(false);
  const [isAnyRowChecked, setIsAnyRowChecked] = useState(false);
  const [actionClass, setActionClass] = useState("");
  const [rowId, setRowId] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [sortValue, setSortValue] = useState(true);
  const [startLoading, setStartLoading] = useState(false);
  const [endLoading, setEndLoading] = useState(false);
  
  const { t } = useTranslation();


  useEffect(() => {
    if (removable) {
      setActionClass("fixed-column3");
    } else if (isViewVisible) {
      setActionClass("fixed-column1");
    } else {
      setActionClass("fixed-column2");
    }
  }, [removable, isViewVisible]);

  useEffect(() => {
    if (onActionClick) {
      onActionClick(selectedRows);
    }
  }, [selectedRows]);

  useEffect(() => {
    if (clearAll) {
      clearAllSelected();
    }
  }, [clearAll]);

  const statusColorMap: { [key: string]: string } = {
    InProgress: "inprogress",
    Pending: "pending",
    Completed: "completed",
    "Waiting for Lab Approval": "qa_waiting_approval",
    "Lab APPROVED": "ready_to_use",
    "Ready To Use": "ready_to_use",
    "Activity Inprogress": "under_test",
    "Lab REJECTED": "rejected",
    "Quarantine": "quarantine",
    "Lab Approved": "ready_to_use",
    "Lab Rejected": "rejected",
    "Lab Pending" : "pending"
    // Add mappings for other status values here
  };

  const filteredItem = data.filter((item: any) => {
    return item.slno === selectedRows[0];
  });

  // Only consider rows where slno is not empty and not completed for select all checkbox state
  const selectableRows = data.filter(row => 
    row.slno !== " " && 
    row.role !== "Admin" && 
    row.is_completed !== "Completed"
  );
  const isHeaderCheckboxChecked = selectableRows.length > 0 && 
    selectableRows.every(row => selectedRows.includes(row.slno));
  // const tableData = data[0]?.loading ? [] : data;
  const tableData = useMemo(() => (data[0]?.loading ? [] : data), [data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setFilter,
    setGlobalFilter,
    state,
  } = useTable(
    {
      columns,
      data : tableData,
    },
    useFilters,
    useGlobalFilter
  );

  const { globalFilter } = state;

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value || undefined;
    setGlobalFilter(value);
  };

  function handleEdit(areaCode: any) {
    // Here, you can perform the edit action using the areaCode
    console.log("Edit button clicked for area code:", areaCode);
    // Implement your edit logic here
  }

  const toggleRowSelected = (rowId: string, isCompleted: boolean) => {
    // Prevent toggling if the row is already completed and we're trying to deselect it
    if (isCompleted && selectedRows.includes(rowId)) {
      return;
    }
    
    setSelectedRows((prevSelectedRows) => {
      const updatedSelectedRows = prevSelectedRows.includes(rowId)
        ? prevSelectedRows.filter((id) => id !== rowId)
        : [...prevSelectedRows, rowId];
      return updatedSelectedRows;
    });
  };

  // const toggleSelectAll = () => {
  //   if (selectedRows.length === data.length) {
  //     // All rows are selected, so unselect all
  //     setSelectedRows([]);
  //   } else {
  //     // Not all rows are selected, so select all
  //     // const allRowIds = data.map((row) => row.slno);
  //     const adminSlNos = data
  //       .filter((row) => row.role !== "Admin")
  //       .map((row) => row.slno);
  //     setSelectedRows(adminSlNos);
  //     // onSelectRow(allRowIds);
  //   }
  // };

  const toggleSelectAll = () => {
    // Filter out rows with empty slno, Admin role, or completed status
    const selectableRows = data.filter(row => 
      row.slno !== " " && 
      row.role !== "Admin" && 
      row.is_completed !== "Completed"
    );
    
    // Get all selectable row IDs
    const selectableSlNos = selectableRows.map(row => row.slno);
    
    // Check if all selectable rows are already selected
    const allSelectableSelected = selectableSlNos.every(slno => 
      selectedRows.includes(slno)
    );
    
    if (allSelectableSelected) {
      // If all selectable rows are selected, unselect all
      setSelectedRows([]);
    } else {
      // Otherwise, select all selectable rows
      setSelectedRows(selectableSlNos);
    }
  };

  const clearAllSelected = () => {
    setSelectedRows([]);
    console.log("clear alll");
  };

  const handleViewClick = (id: string) => {
    const viewValue = true; // Change this based on your logic
    console.log(onViewClick, "onViewClick");
    if (onViewClick) {
      onViewClick(id, viewValue);
    }
    // onViewClick(id, viewValue); // Call the callback with id and viewValue
  };

  // const handleStartButton = () => {
  //   setShowStartAlert(false);
  //   setShowApproveAlert(false);
  //   if (onStartClick) {
  //     onStartClick(selectedRows);
  //   }
  //   setSelectedRows([]);
  // };
  const handleStartButton = async () => {
    try {
      setStartLoading(true);
      if (onStartClick) {
 // Support async handlers; await if a Promise is returned
        await Promise.resolve(onStartClick(selectedRows));
      }
    } finally {
      setShowStartAlert(false);
      setShowApproveAlert(false);
      setSelectedRows([]);
      setStartLoading(false);
    }
  }

  const handleAddButton = () => {
    if (onAddClick) {
      onAddClick();
    }
  };

  const handleActionCheckOrangeButton = () => {
    if (onActionCheckOrangeButtonClick) {
      onActionCheckOrangeButtonClick(selectedRows);
    }
  }

  const handleActionCheckOrangeButton2 = () => {
    if (onActionCheckOrangeButtonClick2) {
      onActionCheckOrangeButtonClick2(selectedRows);
    }
  }

  const handleActionCheckOrangeButton3 = () => {
    if (onActionCheckOrangeButtonClick3) {
      onActionCheckOrangeButtonClick3(selectedRows);
    }
  }

  const handleUploadButton = () => {
    if (onUploadClick) {
      onUploadClick();
    }
  };

  const handleBlueBtnClick = () => {
    if (onBlueBtnClick) {
      onBlueBtnClick();
    }
  };

  const handleStatusChange = (id: string, status: string) => {
    if (onStatusChange) {
      onStatusChange(id, status);
    }
  };

  const handleDiscardButton = () => {
    if (onDiscardClick) {
      onDiscardClick();
    }
  };

  const handleEditClick = (id: string, tableBtnText?: string) => {
    if (onEditClick) {
      onEditClick(id, tableBtnText);
    }
  };

  const handleAssignUserClick = (id : string) => {
    if(onAssignUserClick){
      onAssignUserClick(id);
    }
  }; 

  const handleRoleDepartment = () => {
    if (onRoleDEpartmentClick) {
      onRoleDEpartmentClick(selectedRows);
    }
  };

  const handleRemoveButton = () => {
    if (onRemoveClick) {
      onRemoveClick(rowId);
      setShowRemoveAlert(false);
    }
  };

  const handleRemoveLotButton = () => {
    if (onRemoveClick) {
      onRemoveClick(rowId);
      setShowRemoveLotAlert(false);
    }
  };

  const handleUseEffectRequired = () => {
    if (onUseEffectRequired) {
      onUseEffectRequired();
    }
  };

  // const handleEndButton = () => {
  //   setShowEndAlert(false);
  //   setShowRejectAlert(false);
  //   if (onEndClick) {
  //     onEndClick(selectedRows);
  //   }
  //   setSelectedRows([]);
  // };

  const handleEndButton = async () => {
    try {
      setEndLoading(true);
      if (onEndClick) {
await Promise.resolve(onEndClick(selectedRows));
      }
    } finally {
      setShowEndAlert(false);
      setShowRejectAlert(false);
      setSelectedRows([]);
      setEndLoading(false);
    }
  };


  const handleRemoveClick = (id: any) => {
    setShowRemoveAlert(true);
    setRowId(id);
  };

  const handleRemoveLotClick = (id: any) => {
    setShowRemoveLotAlert(true);
    setRowId(id);
  };

  // const confirmRowRemove = () => {
  //   const updatedData = data.filter((row) => row.slno !== rowId);
  //   // Update the data source
  //   console.log(updatedData, "updatedData")
  //   setData(updatedData);
  //   setShowRemoveAlert(false)
  // }

  const handleRoleChange = (columName: string, e: any) => {
    console.log(e, "---->");
    if (onFilterClick) {
      onFilterClick(columName, e);
    }
  };

  const handleSearchKey = (e: any) => {
    setSearchKey(e);
    if (!e) {
      handleRoleChange("search", e);
    }
  };

  const handleCellClick = (cell: any) => {
    if (onCellClick) {
      onCellClick(cell);
    }
  };

  const handleSortClick = (column: any) => {
    console.log(column, "column")
    if (onSortClick) {
      onSortClick(column.id, sortValue);
      setSortValue(!sortValue);
    }
  };

  const handleLotPassCountChange = (slno: any, value: any) => {
    let numericValue = parseInt(value, 10);
    // Ensure the value is within the min and max range
    if (numericValue < 0) {
      numericValue = 0;
    }
    // } else if (numericValue > 100) {
    //   numericValue = 100;
    // }

    if (onCountChange) {
      onCountChange(slno, numericValue);
    }
  };

  const handleRemarkChange = (slno: any, value: any, label: string) => {
    if (onRemarkChange) {
      onRemarkChange(slno, value, label);
    }
  };

  // const deleteUserTemp = async (id: string) => {
  //   console.log(id , "userStatus");
  //   try {
  //     const response = await userService.deleteUserTemp(id);

  //     if (response.status && response.statusCode === 200) {
  //       handleUseEffectRequired();
  //     }
  //     console.log(response, "response");
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if ( data[0]?.loading) {
      setLoading(true);
    } else if (data.length > 0) {
        // Stop loader if data is already loaded
        setLoading(false);
    } else {
      // Keep loader running for 20 seconds if data is empty
      const timer = setTimeout(() => {
        setLoading(false);
      }, 8000); // 8 seconds
      return () => clearTimeout(timer); // Cleanup timeout
    }
  }, [data]);

  return (
    <>
      {(startLoading || endLoading) && <CustomLoader />}
        {showFullFilters && (
        <div className="fullFilterShow" style={{"flexWrap": "wrap", "justifyContent":"end"}} >
            <FilterSec
              columns={columns}
              handleRoleChange={handleRoleChange}
              plateBatch={plateBatch}
              plateSerialNumber={plateSerialNumber}
              lotCodeNumber={lotCodeNumber}
              areaListNumber={areaListNumber}
              showBatchFilter={showBatchFilter}
              showFromDateFilter={showFromDateFilter}
              showFromDateLabApproval={showFromDateLabApproval}
              showToDateLabApproval={showToDateLabApproval}
              showInventoryFromDateFilter={showInventoryFromDateFilter}
              showToDateFilter={showToDateFilter}
              dateType={dateType}
              showYearFilter={showYearFilter}
              showSerielNoFilter={showSerielNoFilter}
              showLotCodeFilter={showLotCodeFilter}
              showPlateStatus={showPlateStatus}
              areaList={areaList}
              ReasonList={ReasonList}
              reportName={reportName}
              fileStatus={fileStatus}
              ActivityType={ActivityType}
              GradeTypes={GradeTypes}
              prodScheduleList={prodScheduleList}
              productList={productList}
              process={process}
              locationList={locationList}
              areaGrade={areaGrade}
              assignee={assignee}
              generatedby={generatedby}
              locationCategory={locationCategory}
              areaDropList={areaDropList}
              showPlateTypeFilter={showPlateTypeFilter}
              tableHead={tableHead}
            />

            {isSeachable && (
              <div>
                <div>
                  <label htmlFor="areaTypeSelect" className="filterLabel">
                    Search
                  </label>
                </div>
                <div className="areaManagementSearch ms-2">
                  <input
                    type="search"
                    placeholder="Search"
                    onChange={(e) => handleSearchKey(e.target.value)}
                    className="searchInput ps-2"
                  />
                  <BiSearch
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleRoleChange("search", searchKey)}
                    className="m-2"
                    fill="rgba(6, 21, 43, 0.6)"
                    fontSize={20}
                  />
                </div>
              </div>
            )}
        </div>
        )}
      <div className={!showFullFilters? "areaManagementSearchSec" : "fullFilterShow"}>
        <div className="table-left-head">
          <TableButtonSec
            selectedRows={selectedRows}
            tableHead={tableHead}
            totalElements={totalElements}
            startButton={startButton}
            startButtonText={startButtonText}
            endButton={endButton}
            endButtonText={endButtonText}
            addButton={addButton}
            addButtonText={addButtonText}
            buttonWithCloseIcon={buttonWithCloseIcon}
            buttonWithCloseIconText={buttonWithCloseIconText}
            discardButton={discardButton}
            discardButtonText={discardButtonText}
            approveButton={approveButton}
            approveButtonText={approveButtonText}
            changeRoleButton={changeRoleButton}
            changeRoleButtonText={changeRoleButtonText}
            rejectButton={rejectButton}
            rejectButtonText={rejectButtonText}
            addPlateUploadText={addPlateUploadText}
            showBlueBtn={showBlueBtn}
            disableBlueBtn={disableBlueBtn}
            blueBtnText={blueBtnText}
            blueBtnTextTitle={blueBtnTextTitle}
            addPlateUploadBtn={addPlateUploadBtn}
            isQrDownloadable={isQrDownloadable}
            actionCheckOrangeButton={actionCheckOrangeButton}
            actionCheckOrangeBtnText={actionCheckOrangeBtnText}
            actionCheckOrangeButton2={actionCheckOrangeButton2}
            actionCheckOrangeButton3={actionCheckOrangeButton3}
            actionCheckOrangeBtnText2={actionCheckOrangeBtnText2}
            actionCheckOrangeBtnText3={actionCheckOrangeBtnText3}
            data={data}
            setShowStartAlert={setShowStartAlert}
            setShowEndAlert={setShowEndAlert}
            setShowApproveAlert={setShowApproveAlert}
            setShowRejectAlert={setShowRejectAlert}
            clearAllSelected={clearAllSelected}
            handleAddButton={handleAddButton}
            handleActionCheckOrangeButton={handleActionCheckOrangeButton}
            handleActionCheckOrangeButton2={handleActionCheckOrangeButton2}
            handleActionCheckOrangeButton3={handleActionCheckOrangeButton3}
            handleUploadButton={handleUploadButton}
            handleBlueBtnClick={handleBlueBtnClick}
            handleDiscardButton={handleDiscardButton}
            handleRoleDepartment={handleRoleDepartment}
            onCloseBtnClick={onCloseBtnClick}
            onQrDownloadClick={onQrDownloadClick}
          />
        </div>
        {!showFullFilters && (
          <div className="d-flex justify-content-end">
          <FilterSec
            columns={columns}
            handleRoleChange={handleRoleChange}
            plateBatch={plateBatch}
            plateSerialNumber={plateSerialNumber}
            lotCodeNumber={lotCodeNumber}
            areaListNumber={areaListNumber}
            showBatchFilter={showBatchFilter}
            showFromDateFilter={showFromDateFilter}
            showFromDateLabApproval={showFromDateLabApproval}
            showToDateLabApproval={showToDateLabApproval}
            showInventoryFromDateFilter={showInventoryFromDateFilter}
            showToDateFilter={showToDateFilter}
            dateType={dateType}
            showYearFilter={showYearFilter}
            showSerielNoFilter={showSerielNoFilter}
            showLotCodeFilter={showLotCodeFilter}
            showPlateStatus={showPlateStatus}
            areaList={areaList}
            ReasonList={ReasonList}
            reportName={reportName}
            fileStatus={fileStatus}
            ActivityType={ActivityType}
            GradeTypes={GradeTypes}
            prodScheduleList={prodScheduleList}
            productionStatus={productionStatus}
            productList={productList}
            process={process}
            locationList={locationList}
            areaGrade={areaGrade}
            assignee={assignee}
            generatedby={generatedby}
            locationCategory={locationCategory}
            areaDropList={areaDropList}
            showPlateTypeFilter={showPlateTypeFilter}
            tableHead={tableHead}
            showStatusFilter={showStatusFilter}
          />

          {isSeachable && (
            <div>
              <div>
                <label htmlFor="areaTypeSelect" className="filterLabel">
                  Search
                </label>
              </div>
              <div className="areaManagementSearch ms-2">
                <input
                  type="search"
                  placeholder="Search"
                  onChange={(e) => handleSearchKey(e.target.value)}
                  className="searchInput ps-2"
                />
                <BiSearch
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleRoleChange("search", searchKey)}
                  className="m-2"
                  fill="rgba(6, 21, 43, 0.6)"
                  fontSize={20}
                />
              </div>
            </div>
          )}
        </div>
        )}
      </div>
        <div className="d-flex justify-content-end m-2">
          {/* {columns.some((column : any) => column.Header === 'Incubated by') && (
                  <select className='areaTypeSelect mx-3 py-2 mb-2' onChange={(e) => handleRoleChange("Area Name", e.target.value)} >
                      <option>Activity Filter</option>
                      <option value={9}>Pending</option>
                      <option value={12}>Inprogress</option>
                      <option value={13}>Completed</option>
                  </select>
              )} */}
        </div>

      <div className="test12">
        <table className="custom-table" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr
                className="tableHeadRow"
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column: any) => (
                  <th className="tableHeadData2" {...column.getHeaderProps()}>
                    {t(column.Header)}
                    {t(column.Header) !== "Sl.No" && !removeSortList?.includes(column.id) && (
                      <span className="mx-1 inline-flex">
                        <FaSortDown onClick={() => handleSortClick(column)} />
                      </span>
                    )}
                  </th>
                ))}

                {isResetPassword && (
                  <>
                    <th className="tableHeadData2">Password</th>
                  </>
                )}
                {isNavigateFlora && (
                  <>
                    <th className="tableHeadData2">Navigate</th>
                  </>
                )}
                {isTempDeletable && (
                  <>
                    <th className="tableHeadData2">Active / Inactive</th>
                  </>
                )}
                {isEditable && (
                  <>
                    {/* <th className='tableHeadData2'>Edit</th> */}
                    <th className="tableHeadData2">Edit</th>
                  </>
                )}
                {showProcessButton && (
                  <>
                    {/* <th className='tableHeadData2'>Edit</th> */}
                    <th className="tableHeadData2">Add Process</th>
                  </>
                )}
                {showTableBtn && (
                  <>
                    {/* <th className='tableHeadData2'>Edit</th> */}
                    <th className="tableHeadData2">{tableBtnText}</th>
                  </>
                )}
                
                {isToggleStatus && (
                  <>
                    <th className="tableHeadData2 fixed-column2">Status</th>
                  </>
                )}
                {/* {isActionVisible && (
                  <> */}
                    {/* <th className={`tableHeadData2 ${actionClass}`}>
                      <div className="d-flex">
                        <span>Action</span>
                        <label className="custom-checkbox ">
                          <input
                            onClick={toggleSelectAll}
                            checked={isHeaderCheckboxChecked}
                            type="checkbox"
                          />
                          <span className="checkbox-checkmark"></span>
                        </label>
                      </div> */}

                      {/* <input  onClick={toggleSelectAll} checked={isHeaderCheckboxChecked}  className='headerCheckBox' type="checkbox" /> */}
                    {/* </th>
                  </>
                )} */}

                {isActionVisible && (
                  <>
                    <th className={`tableHeadData2 ${actionClass}`}>
                      <div className="d-flex">
                        <span>Action</span>
                        <label className="custom-checkbox">
                          <input
                            onClick={() => {
                              const selectableRows = data.filter(row => row.slno !== " ");
                              if (selectableRows.length > 0) {
                                toggleSelectAll();
                              }
                            }}
                            checked={isHeaderCheckboxChecked}
                            type="checkbox"
                          />
                          <span className="checkbox-checkmark"></span>
                        </label>
                      </div>

                      {/* <input  onClick={toggleSelectAll} checked={isHeaderCheckboxChecked}  className='headerCheckBox' type="checkbox" /> */}
                    </th>
                  </>
                )}


                {isViewVisible && (
                  <>
                    <th className="tableHeadData2 fixed-column2">View</th>
                  </>
                )}
                {/* {isQrDownloadable && (
                <><th className='tableHeadData2 fixed-column2'>Download QR</th></>
            )} */}
                {showRemarkField && (
                  <>
                    <th className="tableHeadData2 fixed-column2">Remarks</th>
                  </>
                )}
                {showReasonField && (
                  <>
                    <th className="tableHeadData2 fixed-column2">Reason</th>
                  </>
                )}
                {removable && (
                  <>
                    <th className="tableHeadData2 fixed-column2"></th>
                  </>
                )}
                {actionButtons &&
                  actionButtons !== null &&
                  Array.isArray(actionButtons) &&
                  actionButtons.map((button) => (
                    <>
                      <th className="tableHeadData2 fixed-column2">
                        {button.thLabel}
                      </th>
                    </>
                  ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            
            {rows?.map((row: any) => {  
              prepareRow(row);
              return (
                <tr
                  className="tableDataRow"
                  onClick={() => onRowClick && onRowClick(row.original.id)}
                  {...row.getRowProps()}
                >
                  {row.cells.map((cell: any) => {
                    const cellValue = cell.value;
                    const content =
                      cellValue !== undefined && cellValue !== ""
                        ? cellValue
                        : "-";
                    // let isUsernameColumn = false
                    // isUsernameColumn = cell?.column?.Header === 'plateInventory.tableColumns.quantity';
                    // isUsernameColumn = cell?.column?.id === 'lot_count';
                    // isUsernameColumn = cell?.column?.id === 'plates_used';
                    const isUsernameColumn =
                      cell?.column?.Header ===
                        "plateInventory.tableColumns.quantity" ||
                      cell?.column?.id === "lot_count" ||
                      cell?.column?.id === "plates_used" ||
                      cell?.column?.id === "remaining_plates_reconciliation";
                    // const isNumeric =
                    //   !isNaN(content) && typeof content === "number";
                    // const numericClass = isNumeric
                    //   ? "tableNumberleftAlign"
                    //   : "";
                    let isNumberInputField = false;
                    isNumberInputField = cell?.column?.Header === "visualInspectionTest.tableColumns.passCount";

                    if (isUsernameColumn) {
                      console.log(cell?.column?.id, isUsernameColumn, "row");
                      const statusClass = "quantity";
                      return (
                        <td
                          className={`tableHeadData ${statusClass}`}
                          onClick={() => handleCellClick(cell)}
                          {...cell.getCellProps()}
                        >
                          {content}
                        </td>
                      );
                    } else if (isNumberInputField) {
                      return (
                        <td className="tableHeadData">
                          <input
                            type="number"
                            defaultValue={row.original.lot_pass_count}
                            value={row.original.lot_pass_count}
                            min="0"
                            // max="100"
                            onChange={(e) => {
                              const value = parseInt(e.target.value);
                              if (value >= 0) {
                                handleLotPassCountChange(
                                  row.original.slno,
                                  value
                                )
                              }
                            }}
                          />
                        </td>
                      );
                    } else {
                      const statusClass = statusColorMap[cellValue] || "";
                      return (
                        <td
                          className={`tableHeadData ${statusClass} ${row.original.slno === " "  ? 'borderBottom' : ''}`}
                          onClick={() => handleCellClick(cell)}
                          {...cell.getCellProps()}
                        >
                          {content}
                        </td>
                      );
                    }
                  })}
                  {isResetPassword && (
                    <td className={`tableHeadData ${row.original.id === row.original?.storage_id  ? 'disabledArea' : ''}`}>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          onResetPassClick &&
                          onResetPassClick(row.original.user_id)
                        }
                        className="ps-3"
                      >
                        <MdLockReset
                          fill="rgba(6, 21, 43, 0.6)"
                          fontSize={25}
                        />
                      </div>
                    </td>
                  )}
                  {isNavigateFlora && (
                    <td className={`tableHeadData`}>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          onNavigateFloraClick &&
                          onNavigateFloraClick(row.original.serial_number)
                        }
                        className="ps-3"
                      >
                        <ImArrowUpRight2
                          fill="rgba(6, 21, 43, 0.6)"
                          fontSize={20}
                          title="Click here to Navigate"
                        />
                      </div>
                    </td>
                  )}
                  {isTempDeletable && (
                    <td
                      style={{ paddingTop: "12px" }}
                      className={`tableHeadData d-flex ${row.original.id === row.original.storage_id  ? 'disabledArea' : ''}`}
                    >
                      <>
                        <Form>
                          <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            className="custom-switch-class"
                            checked={!row.original?.is_deleted}
                            // onChange={() => deleteUserTemp(row.original?.id)}
                            onClick={() =>
                              onTempDeleteClick &&
                              onTempDeleteClick(row.original.id)
                            }
                          />
                        </Form>
                        <p>
                          {!row.original?.is_deleted ? "Active" : "Inactive"}
                        </p>
                      </>

                      {/* <div className='ps-2'><FaTrashAlt className='tableDataDelete' fill='rgba(6, 21, 43, 0.6)' fontSize={18} /></div> */}
                    </td>
                  )}

                  {isEditable && (
                    <>
                      <td className={`tableHeadData 
                         ${
                          row.original?.publish_status === "Published"
                            ? 'disabledAreaEdit'
                            : row.original.id === row.original?.storage_id
                            ? 'disabledArea'
                            : ''
                        }`}>
                        <div
                          style={{ cursor: "pointer" }}
                          className="ps-2 "
                          onClick={() => handleEditClick(row.original.slno)}
                          title={
                            row.original?.publish_status === "Published"
                              ? "Published workflows cannot be edited"
                              : ""
                          }
                                          >
                          <MdEdit fill="rgba(6, 21, 43, 0.6)" fontSize={18} />
                        </div>
                      </td>
                    </>
                  )}
                  {showProcessButton && (
                    <>
                      <td className={`tableHeadData ${row.original?.publish_status === "Published" ? 'disabledArea' : ''}`}>
                        <div
                          style={{ cursor: "pointer" }}
                          className="ps-2 "
                          onClick={() => handleEditClick(row.original.slno, "Add Process")}
                        >
                          <button className="addworkflowProcessBtn">
                            Add Process
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                  {showTableBtn && (row.original.is_executed !== "0") && (
                    <>
                      <td className={`tableHeadData ${row.original?.publish_status === "Published" ? 'disabledArea' : ''}`}>
                        <div
                          style={{ cursor: "pointer" }}
                          className="ps-2 "
                          onClick={() =>
                            handleEditClick(row.original.slno, tableBtnText)
                          }
                        >
                          <button className="tableProcessBtn">
                            {tableBtnText}
                          </button>
                        </div>
                      </td>
                    </>
                  )}

                  {isToggleStatus && (
                    <>
                      <td className={`tableHeadData ${row.original.id === row.original?.storage_id  ? 'disabledArea' : ''}`}>
                        <Form>
                          <Form.Check // prettier-ignore
                            type="switch"
                            id="custom-switch"
                            className="custom-switch-class"
                            checked={row.original?.status === "active"}
                            onClick={() =>
                              handleStatusChange(
                                row.original?.id,
                                row.original?.status
                              )
                            }
                          />
                        </Form>
                      </td>
                    </>
                  )}
                  {isActionVisible && (
                    <>
                      <td className={`tableHeadData ${actionClass} ${(row.original.id === row.original?.storage_id ||row.original.is_completed === "Completed" || row.original.slno === " " ) ? 'disabledArea' : ''}`}>
                        <label className="custom-checkbox">
                          {/* <input
                            checked={selectedRows.includes(row.original.slno)}
                            type="checkbox"
                            onClick={() => toggleRowSelected(row.original.slno)}
                          /> */}
                          <input
                            checked={row.original.is_completed === "Completed" ? false : selectedRows.includes(row.original.slno)}
                            type="checkbox"
                            onChange={() => {}}
                            onClick={() => toggleRowSelected(row.original.slno, row.original.is_completed === "Completed")}
                            style={row.original.is_completed === "Completed" && selectedRows.includes(row.original.slno) ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
                          />
                          <span className="checkbox-checkmark"></span>
                        </label>
                        {/* <input className='ps-2 headerCheckBox' checked={selectedRows.includes(row.original.slno)}  type="checkbox" onClick={() => toggleRowSelected(row.original.slno)} style={{marginLeft : "15px"}}/> */}
                      </td>
                    </>
                  )}
                  {isViewVisible && (
                    <>
                      <td className={`tableHeadData fixed-column2 ${row.original.slno === " " || row.original.downloads_type_id === '1'  ? 'disabledArea' : ''}`}>
                        <div
                          style={{ cursor: "pointer" }}
                          className="ps-2"
                          onClick={() => handleViewClick(row.original.slno)}
                        >
                          <FaEye fill="rgba(6, 21, 43, 0.6)" fontSize={18} />
                        </div>
                      </td>
                    </>
                  )}
                  {/* {isQrDownloadable && (
                <>
                  <td className='tableHeadData'>
                    <div style={{cursor: "pointer"}} className='ps-2' onClick={() => onQrDownloadClick && onQrDownloadClick([row.original.slno], "single")}>
                      <IoMdDownload fill='rgba(6, 21, 43, 0.6)' fontSize={18} />
                    </div>
                  </td>
                </>
              )} */}
                  {showRemarkField && (
                    <>
                      <td className="tableHeadData fixed-column2">
                        <div className="ps-2">
                          <input 
                            type="text"
                            name="remark"
                            id="remark"
                            value={row.original.remark}
                            onChange={(e) => 
                                handleRemarkChange(
                                  row.original.slno,
                                  e.target.value,
                                  "remark"
                                )}
                          />
                        </div>
                      </td>
                    </>
                  )}

                   {showReasonField && (
                    <>
                      <td className="tableHeadData fixed-column2">
                        <div
                          className="ps-2 selectWrap"
                        >
                          {row.original?.status?.includes("Pending") ||
                          removable ? (
                            <select
                              name="reason"
                              id="reason"
                              value={row.original.reason}
                              onChange={(e) => 
                                handleRemarkChange(
                                  row.original.slno,
                                  e.target.value,
                                  "reason"
                                )}
                            >
                              <option value="">Select</option>
                              {inspectionReasons?.map((obj : any, index) => (
                                <option key={index} value={obj?.id}>
                                  {obj?.reason}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <div className="whiteBackground"></div>
                          )}
                        </div>
                      </td>
                    </>
                  )}

                  
                  {removable && (
                    <>
                      <td className="tableHeadData fixed-column2">
                        <div
                          className="ps-2"
                          onClick={() => {
                            if (row.original?.status?.includes("Pending")) {
                              handleRemoveClick(row.original.slno);
                            } else {
                              handleRemoveLotClick(row.original.slno);
                            }
                          }}
                        >
                          {row.original?.status?.includes("Pending") ||
                          removable ? (
                            <button className="tableRemoveBtn">Remove</button>
                          ) : (
                            <div className="whiteBackground"></div>
                          )}
                        </div>
                      </td>
                    </>
                  )}
                  {actionButtons &&
                    actionButtons !== null &&
                    Array.isArray(actionButtons) &&
                    actionButtons.map((button) => (
                      <>
                        <td className="tableHeadData fixed-column2">
                          <div
                            style={{ cursor: "pointer" }}
                            className="ps-2"
                            onClick={() => button.handleAction(row.original)}
                          >
                            <button className="tableProcessBtn">
                              {button.buttonLabel}
                            </button>
                          </div>
                        </td>
                      </>
                    ))}
                </tr>
              );
            })}
          </tbody>
        </table>
        {/* {data.length < 1 && (
          <p className="emptyTableText">Table is empty. No data to display</p>
        )} */}
         {/* <FaMicroscope className="microscope-icon" /> */}
        {loading ? ( 
          <div className="loader-container">
            <div className="spinner"></div>
            <p className="loading-text">Loading... Please wait</p>
          </div>  
        ) : data.length < 1 && (
          <div className="empty-table-container">
          <p className="empty-text">No data to display. Please try again</p>
        </div>
        )}
      </div>

      <AlertModal
        show={showStartAlert}
        onHide={() => setShowStartAlert(false)}
        title="Alert"
        message={`Start Selected ${selectedRows.length} plates ${tableHead}?`}
        onConfirm={handleStartButton}
        isLoading={startLoading}
      />

      <AlertModal
        show={showEndAlert}
        onHide={() => setShowEndAlert(false)}
        title="Alert"
        message={`End Selected ${selectedRows.length} plates ${tableHead}?`}
        onConfirm={handleEndButton}
        isLoading={endLoading}
      />

      <AlertModal
        show={showApproveAlert}
        onHide={() => setShowApproveAlert(false)}
        title="Alert"
        message={approveButtonText === t('deviationIncident.proceed') 
          ? `Proceed the activity as deviation has been rejected` 
          : `Approve the Selected Items`}
        onConfirm={handleStartButton}
      />

      <AlertModal
        show={showRejectAlert}
        onHide={() => setShowRejectAlert(false)}
        title="Alert"
        message={rejectButtonText === t('deviationIncident.stop') 
          ? `Stop the Activity as deviation has been added.` 
          :`Reject the Selected Items`}
        onConfirm={handleEndButton}
      />

      {/* Alert modal for Remove */}
      <Modal centered size="sm" show={showRemoveAlert}>
        <div>
          <div className="modalHead">
            <p className="modalHeadText2 mx-3 my-2">Alert</p>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setShowRemoveAlert(false)}
              className="p-2 mx-2 "
            >
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>
          <div className="text-center mt-3 mb-5">
            <p className="normalText2 ">
              Are you sure want to <br />
              <span>
                <strong> Remove the Plate </strong>
              </span>
            </p>
          </div>
          <div className="d-flex justify-content-around pb-3">
            <button
              onClick={() => setShowRemoveAlert(false)}
              className="modalCancelBtn2"
            >
              Cancel
            </button>
            <button
              onClick={() => handleRemoveButton()}
              className="squareOrangeBtn3"
            >
              Confirm
            </button>
            {/* <button className=' squareOrangeBtn3Disabled'>Submit</button> */}
          </div>
        </div>
      </Modal>

      <Modal centered size="sm" show={showRemoveLotAlert}>
        <div>
          <div className="modalHead">
            <p className="modalHeadText2 mx-3 my-2">Alert</p>
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setShowRemoveLotAlert(false)}
              className="p-2 mx-2 "
            >
              <TfiClose fill="#FFFFFF" />
            </div>
          </div>
          <div className="text-center mt-3 mb-5">
            <p className="normalText2 ">
              Are you sure want to <br />
              <span>
                <strong> Remove the Lot </strong>
              </span>
            </p>
          </div>
          <div className="d-flex justify-content-around pb-3">
            <button
              onClick={() => setShowRemoveLotAlert(false)}
              className="modalCancelBtn2"
            >
              Cancel
            </button>
            <button
              onClick={() => handleRemoveLotButton()}
              className="squareOrangeBtn3"
            >
              Confirm
            </button>
            {/* <button className=' squareOrangeBtn3Disabled'>Submit</button> */}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CustomTable;
